import React, { Fragment, useEffect, useRef, useState } from "react";
import io from "socket.io-client";
import FontAwesomeIcon from "../IME/Icon";
// import { cn } from '../../utilities/classNames';
import ToggleButton from "../../PlayerButtons/ToggleButton";
// import Selector from '../Selector/Selector';
import Volume from "./Volume";

import { evaluate } from "../../../utilities/props";

let socket;

const EmployerStreamVideo = ({ showChat, time, videoduration }) => {
  const ENDPOINT = "localhost:5000";

  time = evaluate(time);
  videoduration = evaluate(videoduration);
  const playerRef = useRef(null);
  const videoRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  // const [, setSubtitle] = useState(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateDuration = () => {
      setDuration(video.duration);
    };
    video.addEventListener("loadedmetadata", updateDuration);

    return () => video.removeEventListener("loadedmetadata", updateDuration);
  }, [setDuration]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateTime = () => {
      setCurrentTime(video.currentTime);
    };
    video.addEventListener("timeupdate", updateTime);
    return () => video.removeEventListener("timeupdate", updateTime);
  }, [currentTime, setCurrentTime]);

  useEffect(() => {
    socket = io(ENDPOINT);

    socket.on("stream", (video) => {
      videoRef.src = video;
    });

    return () => {
      socket.emit("disconnect");

      socket.off();
    };
  }, [ENDPOINT]);
  return (
    <Fragment>
      <div className="live-stream-video-container grey">
        <div className="user-overlay-alt">
          <div
            className={
              showChat
                ? "video-stream-live blue"
                : "video-stream-live-chat blue"
            }
          >
            <i className="fas fa-circle mx-5"></i>
            Live
          </div>
          <div className="alt-left-controls">
            <ul className="controls">
              <Volume
                className="Rac__volume"
                onChange={(level) => {
                  const volume = level / 100;
                  videoRef.current.volume = volume;
                  videoRef.current.muted = volume === 0;
                }}
              />
            </ul>
          </div>
          <div className="icon-flex-expand-settings">
            <ToggleButton
              className="Rac__screen-toggle"
              initial={document.fullscreenElement}
              onChange={(active) => {
                if (!active && KeyboardEvent.key === "Escape") {
                  return document.exitFullscreen();
                }

                return playerRef.current.requestFullscreen({
                  navigationUI: "hide",
                });
              }}
            >
              {(active) => {
                if (!active) {
                  return (
                    <FontAwesomeIcon
                      icon="expand"
                      size="lg"
                      className="mt-4 blue"
                    />
                  );
                }

                if (active) {
                  return (
                    <FontAwesomeIcon
                      icon="compress"
                      size="lg"
                      className="mt-4 blue"
                    />
                  );
                }
              }}
            </ToggleButton>
            <ToggleButton className="">
              {(showSettings) => {
                if (showSettings) {
                  return (
                    <div className="relative-button-container">
                      <li className="control blue">
                        <i className="fas fa-cog fa-lg icon-padding"></i>
                      </li>
                      <div className="video-settings">
                        <ul className="video-setting">
                          <li className="video-option blue bold">Quality</li>
                          <li className="video-option white cursor">
                            Auto
                            <i className="fas fa-chevron-right white mx-10"></i>
                          </li>
                        </ul>
                        <ul className="video-setting">
                          <li className="video-option blue bold">Caption</li>
                          <li className="video-option white cursor">
                            Off
                            <i className="fas fa-chevron-right white mx-10"></i>
                          </li>
                        </ul>
                        <ul className="video-setting">
                          <li className="video-option blue bold">
                            Report Issue
                          </li>
                          <li className="video-option white cursor">
                            <i className="fas fa-chevron-right white mx-10"></i>
                          </li>
                        </ul>
                        <ul className="video-setting">
                          <li className="video-option blue bold">Advanced</li>
                          <li className="video-option white cursor">
                            <i className="fas fa-chevron-right white mx-10"></i>
                          </li>
                        </ul>
                      </div>
                    </div>
                  );
                }

                return (
                  <div className="relative-button-container">
                    <li className="control blue">
                      <i className="fas fa-cog fa-lg icon-padding"></i>
                    </li>
                  </div>
                );
              }}
            </ToggleButton>
          </div>
        </div>
        <video ref={videoRef} className="fill-video" autoPlay={true}></video>
      </div>
    </Fragment>
  );
};

export default EmployerStreamVideo;
